import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Plano } from '../../model/dashboard';

import { DecimalPipe } from '@angular/common';
@Component({
  standalone: true,
    selector: 'app-dashboard-plano',
    imports: [DecimalPipe],
    templateUrl: './dashboard-plano.component.html',
    styleUrl: './dashboard-plano.component.scss'
})
export class DashboardPlanoComponent {
  @Input() plano?: Plano;

  @Output() eventPurchasePlan = new EventEmitter();

  onSelectPlan() {
    this.eventPurchasePlan.emit(this.plano);
  }
}
